// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Button, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { useCarrotCompanion } from "#/components/care-team/hooks/useCarrotCompanion"
import { formatCarrotCompanionName } from "#/components/care-team/utils/carrotCompanionNameUtil"
import { AppointmentsAvatar } from "./AppointmentsAvatar"

export function CarrotCompanionDetails(): JSX.Element {
  const theme = useTheme()
  // Does this hook return need to be exapnded to include the carrot companion bio/details?
  const { data: carrotCompanion } = useCarrotCompanion()
  const { displayName } = formatCarrotCompanionName(carrotCompanion?.name)
  return (
    <Stack sx={{ flexDirection: "column", alignItems: "flex-start" }} spacing={theme.spacing(theme.tokens.spacing.md)}>
      <Typography variant="h3">Carrot Companion</Typography>
      <Stack
        sx={{ flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}
        spacing={theme.spacing(theme.tokens.spacing.md)}
      >
        <AppointmentsAvatar
          name={carrotCompanion?.name ?? ""}
          photoUrl={carrotCompanion?.photoUrl ?? null}
          alt={displayName}
        />
        <Button variant="outlined" color="secondary">
          Send a message
        </Button>
      </Stack>
      <Typography variant="h6">{displayName}</Typography>
      <Typography>
        {/* TODO: replace with carrot companion bio/details from the hook */}
        {
          "Avery P. is a general expert on Carrot, including logistics, choosing a provider, and making the most of your benefit. If Avery is not available, another Carrot Companion will respond."
        }
      </Typography>
      <Typography style={{ fontStyle: "italic" }}>Companions cannot answer medical questions.</Typography>
    </Stack>
  )
}
